/**
 * @description: 商品盈利明细报表
 * @author: lyr
*/
<template>
    <div class="profit-detail-report">
        <div class="red-tip">注：当天营业数据就只能单个营业日</div>
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable  placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input placeholder="请选择包厢区域" v-model="room_area_str" readonly @click.native="openRoomAreaPop"></el-input>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="list_form.room_id" filterable clearable placeholder="请选择包厢" :disabled="list_form.shop_id==''">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢类型">
                    <el-select v-model="list_form.room_type" filterable  placeholder="请选择包厢类型">
                        <el-option v-for="item in room_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单类型">
                    <el-input placeholder="请选择订单类型" v-model="order_type_str" readonly @click.native="openOrderTypePop"></el-input>
                </el-form-item>
                <el-form-item label="支付类型">
                    <el-input placeholder="请选择支付类型" v-model="pay_platform_str" readonly @click.native="openPayPlatformPop"></el-input>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-input placeholder="请选择商品类型" v-model="goods_type_str" readonly @click.native="openGoodsTypePop"></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="list_form.goods_name" clearable placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入预订人姓名" v-model="list_form.book_admin_name">
                        <el-select class="el-slot-select" v-model="list_form.book_admin_type" slot="prepend" placeholder="请选择">
                            <el-option label="员工" value="1"></el-option>
                            <el-option label="艺人" value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="销售类型">
                    <el-input placeholder="请选择销售类型" v-model="info_type_str" readonly @click.native="openInfoTypePop"></el-input>
                </el-form-item>
                <el-form-item label="价格策略">
                    <el-select v-model="list_form.bill_goods_price_rule_id" filterable  placeholder="请选择价格策略">
                        <el-option v-for="item in bill_price_rule_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="checkExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-row">
                <div class="item">折后总额：{{actual_total}}</div>
                <div class="item">成本总额：{{buying_price_total}}</div>
                <div class="item">利润总额：{{profit_price_total}}</div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="room_type_name" label="包厢类型"></el-table-column>
                <el-table-column prop="room_area_name" label="包厢区域"></el-table-column>
                <el-table-column prop="bill_no" label="账单号" width="150"></el-table-column>
                <el-table-column prop="book_admin_name" label="预定员工"></el-table-column>
                <el-table-column prop="order_id" label="订单编号" width="160"></el-table-column>
                <el-table-column prop="order_type_name" label="订单类型"></el-table-column>
                <el-table-column prop="pay_platform_name" label="支付类型"></el-table-column>
                <el-table-column prop="create_time" label="支付时间" width="160"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column prop="goods_name" label="商品名称" width="150"></el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="price" label="单价"></el-table-column>
                <el-table-column prop="quantity" label="净销售数量"></el-table-column>
                <el-table-column prop="actual" label="折后单价"></el-table-column>
                <el-table-column prop="actual_total" label="折后总额"></el-table-column>
                <el-table-column prop="buying_price" label="成本单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="成本总额"></el-table-column>
                <el-table-column prop="profit_price_total" label="利润总额"></el-table-column>
                <el-table-column prop="profit_margin" label="利润率"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
        <!-- 包厢区域选择 -->
        <div class="room-area-pop" ref="room_area_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllRoomArea" @change="handleCheckAllRoomAreaChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.area_ids" @change="handleCheckRoomAreaChange">
                    <el-checkbox v-for="item in room_area_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 订单类型选择 -->
        <div class="order-type-pop" ref="order_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllOrderType" @change="handleCheckAllOrderTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.order_type" @change="handleCheckOrderTypeChange">
                    <el-checkbox v-for="item in order_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 支付类型选择 -->
        <div class="pay-platform-pop" ref="pay_platform_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllPayPlatform" @change="handleCheckAllPayPlatformChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.pay_platform" @change="handleCheckPayPlatformChange">
                    <el-checkbox v-for="item in pay_platform" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 商品类型选择 -->
        <div class="goods-type-pop" ref="goods_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllGoodsType" @change="handleCheckAllGoodsTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.goods_type" @change="handleCheckGoodsTypeChange">
                    <el-checkbox v-for="item in goods_type_list" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 销售类型选择 -->
        <div class="info-type-pop" ref="info_type_pop">
            <div class="checkbox-wrapper">
                <el-checkbox v-model="checkAllInfoType" @change="handleCheckAllInfoTypeChange">全选</el-checkbox>
                <el-checkbox-group v-model="list_form.info_type" @change="handleCheckInfoTypeChange">
                    <el-checkbox v-for="item in info_type_list" :label="item.id" :key="item.id">{{item.name}}（{{item.remark}}）</el-checkbox>
                </el-checkbox-group>
            </div> 
        </div>
        <!-- 预约导出弹窗 -->
        <div class="book-export-pop ele-hide" ref="book_export_pop">
            <div class="red-tip">由于当前导出数据量较大，您需操作预约导出，操作预约导出后，需等待系统生成数据，数据生成完成后可在历史预约中下载查看！数据生成过程中可以关闭当前窗口，可再次操作“导出”进入查看导出进度。</div>
            <div class="pop-row center">
                <el-button type="primary" @click="doBookExport">预约导出</el-button>
                <el-button @click="cancelExport">取消</el-button>
            </div>
            <div class="row-tip">历史预约（注：历史预约仅显示该登录账号最近一次预约操作数据）</div>
            <div class="pop-row bottom" v-if="book_export_log_list.length>0">
                <div class="time">{{book_export_log_list[0].create_time}}</div>
                <div class="right">
                    <span class="status">{{book_export_log_list[0].status_name}}</span>
                    <el-button type="primary" :disabled="book_export_log_list[0].status==0" @click="downloadFile">下载</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'profit-detail-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                room_list: [],
                room_type_list: [],
                order_type_list: [{
                    id: '1',
                    name: '酒水订单'
                }, {
                    id: '2',
                    name: '开房套餐'
                }, {
                    id: '4',
                    name: '续时套餐'
                }, {
                    id: '10',
                    name: '开房小吃'
                }, {
                    id: '11',
                    name: '扫码购买单'
                }, {
                    id: '12',
                    name: '限时秒杀'
                }],
                pay_platform: [],
                goods_type_list: [],
                staff_list: [],
                info_type_list: [{
                    id: '1',
                    name: '仅单品销售',
                    remark: '不含商品套餐/开房套餐内商品'
                }, {
                    id: '2',
                    name: '仅套餐销售内商品',
                    remark: '不含赠送的套餐内商品'
                }, {
                    id: '3',
                    name: '仅赠送',
                    remark: '包含赠送单品和赠送套餐内商品'
                }],
                checkAllRoomArea: false,
                checkAllOrderType: false,
                checkAllPayPlatform: false,
                checkAllGoodsType: false,
                checkAllInfoType: false,
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    area_ids: [],
                    room_id: '0',
                    room_type: '0', // 包厢类型 0全部
                    order_type: [], 
                    pay_platform: [],
                    goods_type: [],
                    book_admin_name: '',
                    book_admin_type: '1', //1员工 2艺人
                    info_type: [], //销售类型 1仅单品销售 2仅套餐销售内商品 3仅赠送
                    goods_name: '',
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                actual_total: 0, // 折后总额
                buying_price_total: 0, // 成本总额
                profit_price_total: 0, // 利润总额
                bill_price_rule_list: [], // 账单价格策略列表
                book_export_log_list: [], // 历史预约
            }
        },
        computed: {
            room_area_str() {
                if (this.list_form.area_ids.length == 0) {
                    return ''
                }else if(this.list_form.area_ids.length == this.room_area_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.area_ids.forEach(v => {
                        this.room_area_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            order_type_str() {
                if (this.list_form.order_type.length == 0) {
                    return ''
                }else if(this.list_form.order_type.length == this.order_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.order_type.forEach(v => {
                        this.order_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            pay_platform_str() {
                if (this.list_form.pay_platform.length == 0) {
                    return ''
                }else if(this.list_form.pay_platform.length == this.pay_platform.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.pay_platform.forEach(v => {
                        this.pay_platform.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            goods_type_str() {
                if (this.list_form.goods_type.length == 0) {
                    return ''
                }else if(this.list_form.goods_type.length == this.goods_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.goods_type.forEach(v => {
                        this.goods_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },

            info_type_str() {
                if (this.list_form.info_type.length == 0) {
                    return ''
                }else if(this.list_form.info_type.length == this.info_type_list.length) {
                    return '全部'
                }else {
                    let res = []
                    this.list_form.info_type.forEach(v => {
                        this.info_type_list.forEach(item => {
                            if (item.id == v) {
                                res.push(item.name)
                            }
                        })
                    })
                    return res.join(',')
                }
            },
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.list_form.shop_id)
                this.getRoom(this.list_form.shop_id)
                this.getRoomType(this.list_form.shop_id)
                this.getPayType(this.list_form.shop_id)
                this.getGoodsType()
                this.getStaffList(this.list_form.shop_id)
                this.getBillPriceRule(this.list_form.shop_id)
                this.getList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getRoomArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_area_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢类型
            getRoomType: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getRoomType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_type_list = res.data.response.result.data;
                        _this.room_type_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取员工
            getStaffList: function(shop_id) {
                const _this = this;

                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.staff_list = res.data.response.result;
                        _this.staff_list.unshift({
                            id: '',
                            name: '全部'
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取支付类型
            getPayType: function(shop_id) {
                const _this = this;

                Vue.axios.post('Order/getAllPayPlatform', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        let arr = [];
                        for(let [key, value] of Object.entries(res.data.response.data)) {
                            arr.push({id: key, name: value});
                        }
                       _this.pay_platform = arr
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                        _this.room_list.unshift({
                            id: '0',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取账单价格策略列表
            getBillPriceRule: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getBillGoodsPriceRule', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.bill_price_rule_list = res.data.response.result;
                        _this.bill_price_rule_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
           
            getList(page) {
				const _this = this;

				_this.loading = true;
                _this.list_page = page;
				Vue.axios.post('Report/getGoodsSalesDetailList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
							"area_ids": _this.list_form.area_ids,
                            "room_id": _this.list_form.room_id,
                            "room_type": _this.list_form.room_type, // 包厢类型 0全部
                            "order_type": _this.list_form.order_type, 
                            "pay_platform": _this.list_form.pay_platform,
                            "goods_type": _this.list_form.goods_type,
                            "book_admin_name": _this.list_form.book_admin_name,
                            "book_admin_type": _this.list_form.book_admin_type, //1员工 2艺人
                            "info_type": _this.list_form.info_type, //销售类型 1仅单品销售 2仅套餐销售内商品 3仅赠送
                            "goods_name": _this.list_form.goods_name,
                            "bill_goods_price_rule_id": _this.list_form.bill_goods_price_rule_id,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
                            _this.actual_total = res.data.response.result.actual_total
                            _this.buying_price_total = res.data.response.result.buying_price_total
                            _this.profit_price_total = res.data.response.result.profit_price_total
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.list_form.area_ids = []
                    this.list_form.room_id = '0'
                    this.list_form.room_type = '0'
                    this.list_form.pay_platform = []
                    this.list_form.book_admin_name = ''
                 
                    this.getRoomArea(val)
                    this.getRoom(val)
                    this.getRoomType(val)
                    this.getPayType(val)
                    this.getStaffList(val)
                    this.getBillPriceRule(val)
                }
            },

            // 打开包厢区域选择弹窗
            openRoomAreaPop() {
                let _this = this
                let c_area_ids = _this.list_form.area_ids
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.room_area_pop),
                    cancel: function() {
                        _this.list_form.area_ids = c_area_ids
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.area_ids = c_area_ids
                    layer.closeAll()
                });
            },

            // 包厢区域全选
            handleCheckAllRoomAreaChange(val) {
                this.list_form.area_ids = []
                this.checkAllRoomArea = val
                if (val) {
                    this.room_area_list.forEach(item => {
                        this.list_form.area_ids.push(item.id)
                    })
                }
            },

            // 选择包厢区域
            handleCheckRoomAreaChange(val) {
                this.checkAllRoomArea = val.length === this.room_area_list.length
            },

            // 打开订单类型选择弹窗
            openOrderTypePop() {
                let _this = this
                let c_order_type = _this.list_form.order_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择订单类型', true],
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.order_type_pop),
                    cancel: function() {
                        _this.list_form.order_type = c_order_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.order_type = c_order_type
                    layer.closeAll()
                });
            },

            // 订单类型全选
            handleCheckAllOrderTypeChange(val) {
                this.list_form.order_type = []
                this.checkAllOrderType = val
                if (val) {
                    this.order_type_list.forEach(item => {
                        this.list_form.order_type.push(item.id)
                    })
                }
            },

            // 选择订单类型
            handleCheckOrderTypeChange(val) {
                this.checkAllOrderType = val.length === this.order_type_list.length
            },

            // 打开支付类型选择弹窗
            openPayPlatformPop() {
                let _this = this
                let c_pay_platform = _this.list_form.pay_platform
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择支付类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.pay_platform_pop),
                    cancel: function() {
                        _this.list_form.pay_platform = c_pay_platform
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.pay_platform = c_pay_platform
                    layer.closeAll()
                });
            },

            // 支付类型全选
            handleCheckAllPayPlatformChange(val) {
                this.list_form.pay_platform = []
                this.checkAllPayPlatform = val
                if (val) {
                    this.pay_platform.forEach(item => {
                        this.list_form.pay_platform.push(item.id)
                    })
                }
            },

            // 选择支付类型
            handleCheckPayPlatformChange(val) {
                this.checkAllPayPlatform = val.length === this.pay_platform.length
            },

            // 打开商品类型选择弹窗
            openGoodsTypePop() {
                let _this = this
                let c_goods_type = _this.list_form.goods_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['550px', ''], // 宽高
                    content: $(_this.$refs.goods_type_pop),
                    cancel: function() {
                        _this.list_form.goods_type = c_goods_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.goods_type = c_goods_type
                    layer.closeAll()
                });
            },

            // 商品类型全选
            handleCheckAllGoodsTypeChange(val) {
                this.list_form.goods_type = []
                this.checkAllGoodsType = val
                if (val) {
                    this.goods_type_list.forEach(item => {
                        this.list_form.goods_type.push(item.id)
                    })
                }
            },

            // 选择商品类型
            handleCheckGoodsTypeChange(val) {
                this.checkAllGoodsType = val.length === this.goods_type_list.length
            },

            // 打开销售类型选择弹窗
            openInfoTypePop() {
                let _this = this
                let c_info_type = _this.list_form.info_type
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择销售类型', true],
                    area: ['500px', '300px'], // 宽高
                    content: $(_this.$refs.info_type_pop),
                    cancel: function() {
                        _this.list_form.info_type = c_info_type
                    }
                }, function() {
                    layer.closeAll()
                }, function() {
                    _this.list_form.info_type = c_info_type
                    layer.closeAll()
                });
            },

            // 销售类型全选
            handleCheckAllInfoTypeChange(val) {
                this.list_form.info_type = []
                this.checkAllInfoType = val
                if (val) {
                    this.info_type_list.forEach(item => {
                        this.list_form.info_type.push(item.id)
                    })
                }
            },

            // 选择销售类型
            handleCheckInfoTypeChange(val) {
                this.checkAllInfoType = val.length === this.info_type_list.length
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },

            // 检查导出状态
            checkExport() {
                let _this = this;
                Vue.axios.post('exportBook/exportCheck', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'goodsSalesDetail',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "area_ids": _this.list_form.area_ids,
                            "room_id": _this.list_form.room_id,
                            "room_type": _this.list_form.room_type, // 包厢类型 0全部
                            "order_type": _this.list_form.order_type,
                            "pay_platform": _this.list_form.pay_platform,
                            "goods_type": _this.list_form.goods_type,
                            "book_admin_name": _this.list_form.book_admin_name,
                            "book_admin_type": _this.list_form.book_admin_type, //1员工 2艺人
                            "info_type": _this.list_form.info_type, //销售类型 1仅单品销售 2仅套餐销售内商品 3仅赠送
                            "goods_name": _this.list_form.goods_name,
                            "bill_goods_price_rule_id": _this.list_form.bill_goods_price_rule_id,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        layer.closeAll()
                        if (res.data.response.result.status == '1') { // 原逻辑直接导出
                            _this.listExport();
                        }else {
                            _this.book_export_log_list = res.data.response.result.log_list
                            // 预约导出弹窗
                            layer.confirm('', {
                                skin: 'public-alert-skin',
                                type: 1,
                                btn: [], // 按钮
                                title: ['导出提示', true],
                                area: ['700px', ''], // 宽高
                                content: $(_this.$refs.book_export_pop),
                                offset: '100px',
                            });
                        }

                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 预约导出
            doBookExport() {
                let _this = this

                Vue.axios.post('exportBook/addExportBook', {
                    "header": Vue.request_header,
                    "request": {
                        "type": 'goodsSalesDetail',
                        "param": {
                            "page": _this.list_page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "area_ids": _this.list_form.area_ids,
                            "room_id": _this.list_form.room_id,
                            "room_type": _this.list_form.room_type, // 包厢类型 0全部
                            "order_type": _this.list_form.order_type,
                            "pay_platform": _this.list_form.pay_platform,
                            "goods_type": _this.list_form.goods_type,
                            "book_admin_name": _this.list_form.book_admin_name,
                            "book_admin_type": _this.list_form.book_admin_type, //1员工 2艺人
                            "info_type": _this.list_form.info_type, //销售类型 1仅单品销售 2仅套餐销售内商品 3仅赠送
                            "goods_name": _this.list_form.goods_name,
                            "bill_goods_price_rule_id": _this.list_form.bill_goods_price_rule_id,
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.book_export_log_list = res.data.response.result.log_list
                    } else {
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 下载文件
            downloadFile() {
                // 已知文件的URL
                const fileUrl = this.book_export_log_list[0].file_url
                const fileName = "file.pdf"; // 自定义文件名

                // 创建一个隐藏的 <a> 元素
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = fileName;

                // 将 <a> 元素添加到页面中
                document.body.appendChild(a);

                // 触发点击事件，下载文件
                a.click();

                // 下载完成后移除该 <a> 元素
                document.body.removeChild(a);
            },

            cancelExport() {
                layer.closeAll()
            },

            
            listExport: function() {
                window.location.href = Vue.ctUrl + "Report/goodsSalesDetailExport" +
                    "?start_date=" + this.list_form.start_time +
                    "&end_date=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&area_ids=" + this.list_form.area_ids +
                    "&room_id=" + this.list_form.room_id +
                    "&room_type=" + this.list_form.room_type +
                    "&order_type=" + this.list_form.order_type + 
                    "&pay_platform=" + this.list_form.pay_platform +
                    "&goods_type=" + this.list_form.goods_type +
                    "&book_admin_name=" + this.list_form.book_admin_name +
                    "&book_admin_type=" + this.list_form.book_admin_type +
                    "&info_type=" + this.list_form.info_type +
                    "&goods_name=" + this.list_form.goods_name + 
                    "&bill_goods_price_rule_id=" + this.list_form.bill_goods_price_rule_id;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .red-tip {
        color: red;
        margin-bottom: 10px;
    }

    .total-row {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 50px;
        }
    }

    .room-area-pop,
    .order-type-pop,
    .pay-platform-pop,
    .goods-type-pop,
    .info-type-pop {
        display: none;
        .el-checkbox {
            width: 150px;
            margin-bottom: 10px;
            margin-right: 10px;
        }
    }
    .info-type-pop {
        .el-checkbox {
            width: 320px;
        }
    }
    // 预约导出
    .book-export-pop {
        position: relative;
        .red-tip {
            color: red;
        }
        .pop-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            &.center {
                margin: 30px 0 60px 0;
                justify-content: center;
            }
            &.bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                padding: 0 35px;
                box-sizing: border-box;
                justify-content: space-between;
                .right {
                    .status {
                        margin-right: 10px;
                        color: #409EFF;
                    }
                }
            }
        }
        .row-tip {
            margin-bottom: 20px;
        }
        .el-button {
            width: 100px;
        }
    }
</style>